import React from 'react';

interface DFFilesLogoProps {
  /** Font size in px for the logo text */
  size?: number;
  /** Color variant */
  variant?: 'light' | 'dark';
  className?: string;
}

/**
 * DFFiles styled logo text component.
 * "DF" is bold with accent color, "Files" is light weight with muted color.
 * A small gate/shield icon precedes the text.
 */
const DFFilesLogo: React.FC<DFFilesLogoProps> = ({
  size = 20,
  variant = 'light',
  className,
}) => {
  const isDark = variant === 'dark';
  const primaryColor = isDark ? '#1a0000' : '#ffffff';
  const accentColor = isDark ? '#8b1a1a' : '#ff8a80';
  const mutedColor = isDark ? '#475569' : 'rgba(255,255,255,0.7)';
  const iconSize = size * 1.1;

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: size * 0.35,
        fontFamily: "'Outfit', sans-serif",
        fontSize: `${size}px`,
        lineHeight: 1,
        letterSpacing: '-0.02em',
        userSelect: 'none',
      }}
    >
      {/* Shield + flow icon */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 32 32"
        fill="none"
        style={{ flexShrink: 0 }}
      >
        {/* Shield outline */}
        <path
          d="M16 3 L27 8 V17 C27 23 22 27.5 16 29 C10 27.5 5 23 5 17 V8 Z"
          fill={accentColor}
          opacity="0.18"
        />
        <path
          d="M16 3 L27 8 V17 C27 23 22 27.5 16 29 C10 27.5 5 23 5 17 V8 Z"
          stroke={accentColor}
          strokeWidth="1.6"
          fill="none"
          opacity="0.6"
        />
        {/* Double chevron — data flow through gate */}
        <path
          d="M11 13 L15.5 16 L11 19"
          stroke={accentColor}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.5"
        />
        <path
          d="M16 13 L20.5 16 L16 19"
          stroke={accentColor}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Text: DF */}
      <span style={{ fontWeight: 700, color: accentColor }}>
        DF
      </span>
      {/* Text: Files */}
      <span style={{ fontWeight: 300, color: mutedColor, marginLeft: `-${size * 0.08}px` }}>
        Files
      </span>
    </span>
  );
};

export default DFFilesLogo;
